<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Customer
 * @created at      :   2024/07/16
 * @created by      :   sondh – sondh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import { mapMutations } from 'vuex';
// import messages from '@/utils/messages';
/**
 * Define component for popup
 */

const data = [
    {
        responsible_person_cd: '001',
        responsible_person_name: 'コントロールセン'
    },
    {
        responsible_person_cd: '002',
        responsible_person_name: '新宿'
    },
    {
        responsible_person_cd: '003',
        responsible_person_name: '渋谷オフィス'
    },
    {
        responsible_person_cd: '004',
        responsible_person_name: '立川オフィス'
    },
    {
        responsible_person_cd: '005',
        responsible_person_name: 'マーケティング'
    },
    {
        responsible_person_cd: '006',
        responsible_person_name: 'トライアルオフ'
    }
];
const paging = {
    totalRecord: '11',
    pageMax: '2',
    page: '1',
    pagesize: '10',
    offset: '1'
};

var Customer = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    created() {
        this.onSearchItem();
    },
    data() {
        return {
            searchResult: [],
            searchParams: {
                responsible_person_cd: '',
                responsible_person_name: '',
                page_size: 10,
                page_no: 1
            },
            msgNoData: '',
            paging: {}
        };
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        tableResult() {
            return data;
        }
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        onSearchItem() {
            this.search(this.searchParams);
        },
        search(param) {
            console.log(param);
            this.searchResult = data;
            this.paging = paging;
            this.msgNoData = '';
        },
        changeCurrentPage(data) {
            this.search({
                ...this.searchParams,
                page_size: data.perPage,
                page_no: data.currentPage
            });
        },
        chooseCustomer(data) {
            this.$emit('close');
            this.$emit('onReferModelValue', data.responsible_person_cd);
            this.$emit('onReferValueName', data.responsible_person_name);
        }
    }
};
export default Customer;
</script>
